import { isValidEmail } from "../../../utils/formatUtils";

const validateEmail = (value) => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return "Please enter email";
  }
  if (!isValidEmail(trimmed)) {
    return "Please enter a valid email address";
  }
  return null;
};

const validateMobilePhone = (value) => {
  const input = (value || "").trim();
  if (!input) {
    return "Please enter mobile phone number";
  }
  const digitsOnly = input.replace(/\D/g, "");
  if (digitsOnly.length !== 10) {
    return "Please enter a valid 10-digit phone number";
  }
  const hasRepeatingDigits = /(\d)\1{5,}/.test(digitsOnly);
  const isSequential =
    "01234567890123456789".includes(digitsOnly) ||
    "98765432109876543210".includes(digitsOnly);
  if (hasRepeatingDigits || (isSequential && digitsOnly.length >= 5)) {
    return "Please enter a valid phone number";
  }
  return null;
};

/**
 * Validates a single field in the General and Contact Details form.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @param {object} formData - Form data object
 * @returns {string|null} - Error message or null if valid
 */
export const validateGeneralContactField = (name, value, formData = {}) => {
  if (name === "mobileNumber") {
    return validateMobilePhone(value);
  }
  if (name === "email") {
    return validateEmail(value);
  }
  if (name === "dob") {
    if (!value?.trim()) return "Please enter Date of Birth";
    return null;
  }
  if (name === "gender") {
    if (!value?.trim()) return "Please select Gender";
    return null;
  }
  if (name === "countryCode") {
    if (!value?.trim()) return "Please enter Country Code";
    return null;
  }
  return null;
};

export const validateGeneralContactForm = (formData) => {
  const errors = {};

  const mobileError = validateGeneralContactField(
    "mobileNumber",
    formData.mobileNumber || "",
    formData,
  );
  if (mobileError) errors.mobileNumber = mobileError;

  const emailValError = validateGeneralContactField(
    "email",
    formData.email || "",
    formData,
  );
  if (emailValError) errors.email = emailValError;

  const dobError = validateGeneralContactField(
    "dob",
    formData.dob || "",
    formData,
  );
  if (dobError) errors.dob = dobError;

  const genderError = validateGeneralContactField(
    "gender",
    formData.gender || "",
    formData,
  );
  if (genderError) errors.gender = genderError;

  const countryCodeError = validateGeneralContactField(
    "countryCode",
    formData.countryCode || "",
    formData,
  );
  if (countryCodeError) errors.countryCode = countryCodeError;

  return errors;
};
